import React from 'react'
import { useNavigate } from 'react-router-dom'
import PopOption from './popOptions'

const InnvoLightRoutes = ({
  onClose,
  onCloseMob,
  isColumnView,
  hideTitle,
}: {
  onClose: any
  onCloseMob?: any
  isColumnView?: boolean
  hideTitle?: boolean
}) => {
  const navigate = useNavigate()

  return (
    <>
      {!hideTitle && (
        <span className="block pb-1 text-base font-medium text-black font-regular lg:text-base">
          OCT
        </span>
      )}
      <div
        className={`${
          isColumnView
            ? 'grid grid-cols-2 gap-x-6'
            : 'flex flex-col items-start -mt-1 md:mt-0'
        }`}
      >
        <PopOption
          text="InnvoLight"
          //   symbol="®"
          callback={() => {
            navigate('/products/innvolight')
            onClose()
            onCloseMob && onCloseMob()
          }}
        />
      </div>
    </>
  )
}

export default InnvoLightRoutes
